var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseAttachmentList',{attrs:{"loading":false,"attachments":_vm.material.attachments},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('MaterialAttachmentForm',{attrs:{"id":parseInt(_vm.material.id)}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }